import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

export const BootstrapModal = styled(Modal)`
  .custom-modal {
    max-width: 68%;
    margin: auto;
    margin-top: 20px;
    @media (max-width: 1280px) {
      max-width: 98%;
    }
  }
  .modal-header {
    height: 100px;
    padding: 0px 60px;
    background: #fff;
    color: #58079e;
    border-bottom: transparent;

    .modal-title {
      margin-top: auto;
      width: 100%;
      border-bottom: 1px solid #dee2e6;
      @media (max-width: 1280px) {
        margin-top: 0;
      }
    }
    @media (max-width: 1280px) {
      padding: 0px 30px;
    }
  }
  .modal-body {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding-left: 60px;
    padding-right: 60px;

    @media (max-width: 1280px) {
      padding: 0px 30px 0px 30px;
    }

    .botoes-de-filtro {
      button {
        padding: 0 10px;
        height: 24px;
        background: #c6c6c6;
        border: none;

        cursor: pointer;
        & + button {
          margin-left: 2px;
        }
      }
    }
    .aba-ativa {
      background: ${(props) => props.theme.colors.nav} !important;
      color: #fff;
    }
    .modal-acoes {
      height: 70px;
      transition: 0.3s;
      cursor: pointer;

      & + .modal-acoes {
        border-top: 1px solid #ededed;
      }
      & + a {
        border-top: 1px solid #ededed !important;
      }
      h5 {
        font-size: 18px;
        color: #474747;
      }
      small {
        font-size: 13px;
      }
      svg {
        color: ${(props) => props.theme.colors.nav} !important;
      }
    }
    .executando {
      background: #ebebeb;
      transition: 0.3s;

      cursor: default;
      h5 {
        color: #a19d9d !important;
      }
      small {
        color: #a19d9d !important;
      }
      svg {
        color: #9d7dbd !important;
      }
      -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
      -khtml-user-select: none; /* Konqueror HTML */
      -moz-user-select: none; /* Old versions of Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
    }
    .nav-tabs {
      .nav-item {
        & + .nav-item {
          display: none;
          visibility: hidden;
        }
      }
    }
    .button-confirm {
      margin-top: 31px;
    }
  }
  .modal-footer {
    padding-right: 75px;

    color: #58079e;
    button {
      background: ${(props) => props.theme.colors.nav};
      border-color: ${(props) => props.theme.colors.nav};

      &:focus:not(.focus-visible) {
        outline: none !important;
        outline: 0px !important;
        -webkit-appearance: none;
        box-shadow: none !important;
      }
      &:focus-visible {
        outline: 2px solid ${(props) => props.theme.colors.nav} !important;
      }
    }
  }

  .input-qtd {
    outline: none;
    box-sizing: border-box;
    margin: 0;
    display: block;
    width: 100px;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-clip: padding-box;
    appearance: none;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    border: 2px solid var(--ds-border-neutral, #dfe1e6);
    background-color: #fff;
    padding: 8px 6px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
      'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    font-size: 14px;
    text-align: right;
  }
  .is-invalid {
    background-image: none;
    border: 2px solid var(--ds-border-neutral, #dfe1e6);
    border-bottom: 2px solid #cf1919;
    &:focus {
      box-shadow: none;
    }
    padding: 0.375rem 0.75rem;
  }
`;

export const ButtonSeparator = styled.button`
  border: none;
  background: none;
  color: #8850bf;
`;

export const ContentSeparator = styled.div`
  display: flex;
  text-align: center;
  justify-content: flex-end;
  color: #8850bf;
  gap: 10px;
`;
export const ColumnSeparator = styled.div`
  color: rgba(224, 224, 224, 1);
  right: -12px;
  display: flex;
  position: absolute;
  flex-direction: column;
  justify-content: center;
  min-height: 56px;
  opacity: 1;
  top: 0;

  .MuiSvgIcon-root {
    width: 1.1em;
  }
`;

export const Container = styled.div`
  overflow: auto;
  display: flex;
  position: relative;
  width: 100%;
  z-index: 0;
  .selected {
    background: #d1e7dd !important;
    border-color: #badbcc;
    &:hover {
      background: #d1e7dd;
    }
  }
  .rowTable:hover td {
    background: #fff;
  }
  svg {
    height: 20px;
  }
`;

export const TableEmpty = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 60px;
  h3 {
    font-size: 10pt;
    color: var(--ds-text-lowEmphasis, var(--ds-text-lowEmphasis, #6b778c));
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
      'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
  }
`;
